import { render, staticRenderFns } from "./loginLayout.vue?vue&type=template&id=3531dfba&"
import script from "./loginLayout.vue?vue&type=script&lang=js&"
export * from "./loginLayout.vue?vue&type=script&lang=js&"
import style0 from "./loginLayout.vue?vue&type=style&index=0&id=3531dfba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports